module.exports = __webpack_public_path__ + "static/media/mk.03d7a047.svg";